import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Amplifybrand() {
  return (
    <section className="amplify_brand p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center order-2 order-md-1"
          >
            <StaticImage
              src="../../images/services-usa/social-media/amplify_brand.webp"
              alt="tekrevol_web"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={629}
              height={518}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="offset-lg-1 order-1 order-md-2"
          >
            <h2>
              Amplify your Brand with <span>Social Media</span>
            </h2>
            <h6
              style={{
                color: "#314252",
                marginBottom: "10px",
                background: "#f8f8f8",
                padding: "5px",
              }}
            >
              Wondering, how can social media contribute to your business?
            </h6>
            <p>
              Did you know that most businesses—over 90%—use social media to
              connect with their customers? Even more impressive, 70% of
              marketers are hitting the mark, effectively reaching their target
              audience through well-planned social media campaigns. So it's
              pretty clear that this platform is a game-changer as far as your
              business goals are concerned.
            </p>
            <p>
              Grab the attention of your audience, and watch your brand prosper
              in the digital world with our social media marketing services!
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Amplifybrand;
